import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import axios from 'axios';
import { api } from '../../../api';
import { Empty } from 'antd';

// Enregistrement des éléments nécessaires dans ChartJS
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = () => {
  const [aboMensuel, setAboMensuel] = useState({});
  
  const getAbonnementsParMois = async () => {
      try {
        const response = await axios.get(api + '/api/getAbonnementsParMois');
        setAboMensuel(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
  };

  useEffect(() => {
      getAbonnementsParMois()
    }, []);

  // Données du graphique
  const data = {
    labels: ['Janv', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
    datasets: [
      {
        label: ['Total'],
        data: [aboMensuel[1],aboMensuel[2],aboMensuel[3],aboMensuel[4],aboMensuel[5],aboMensuel[6],aboMensuel[7],aboMensuel[8],aboMensuel[9],aboMensuel[10],aboMensuel[11],aboMensuel[12]],
        
        backgroundColor: [
          'rgb(77, 219, 255, 1)',
          'rgb(169, 169, 169)',
        ],
        borderColor: [
          'rgb(77, 219, 255, 1)',
          'rgb(169, 169, 169)',
        ],
        borderWidth: 1,
      },
    ],
  };

    // <div className="w-full h-96"> 
    //   <Bar data={data} options={options} height={300} />
    // </div>

  // Options de configuration du graphique
  const options = {
    responsive: true,
    plugins: {
      legend: { display: false }, // Désactiver l'affichage des légendes
      // legend: { position: 'top' }, // Légendes en haut du graphique
      // title: { display: true, text: 'Sales by Month' }, // Titre du graphique
    },
    scales: {
      y: { beginAtZero: true }, // L'axe Y commence à 0
    },
  };

  return (
    
    <div className="w-full h-auto p-1 mt-2 bg-white border border-gray-200 shadow-lg rounded-lg">
      
      <div className="w-full h-40 sm:h-64 md:h-80 lg:h-72 flex justify-center items-center my-12">
        <Bar data={data} options={options} height={100} />
      </div>
    </div>)

    // <div className="w-full h-96"> 
    //    <Bar data={data} options={options} height={300} />
    // </div> )
};

export default BarChart;
